﻿import { RadioButtonValgModel } from '../../Shared/Scripts/Components/RadioButtonValg';
import VeilederBsDto from '../Models/VeilederBsDto';

const merEnn3Timer = 'b1-ja';
const mindreEnn3Timer = 'b2-nei';

const bValg: RadioButtonValgModel<VeilederBsDto>[] = [
    {
        id: 'b1',
        value: merEnn3Timer,
        tekst: 'valgMerEnn3Timer',
    },
    {
        id: 'b2',
        value: mindreEnn3Timer,
        tekst: 'valgMindreEnn3Timer',
    },
];

export default {
    b1_merEnn40km: merEnn3Timer,
    b2_mindreEnn40km: mindreEnn3Timer,
    bValg,
};
